import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
// eslint-disable-next-line no-unused-vars
import ReactSelect, { CreatableProps } from 'react-select/creatable';
import PropTypes from 'prop-types';

const styles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: 6,
        background: state.isFocused ? 'white' : '#ecf4ff',
        height: 40,
        border: 'unset !important'
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: '1000 !important'
    }),
    input: (provided) => ({
        ...provided,
        borderRadius: 6,
        background: '#f5f7fa',
        display: 'flex',
        alignItems: 'center'
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    option: (provided) => ({
        ...provided,
        textAlign: 'left'
    })
};
const labstyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: 4,
        background: 'white',
        height: 36,
        border: '1px solid #e3e7ed !important'
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: '1000 !important'
    }),
    input: (provided) => ({
        ...provided,
        borderRadius: 4,
        background: '#f5f7fa',
        display: 'flex',
        alignItems: 'center'
    }),
    DropdownIndicator: () => null,
    indicatorSeparator: (prev) => ({ ...prev, display: 'none' }),
    option: (provided) => ({
        ...provided,
        textAlign: 'left'
    })
};
const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: 200,
        margin: '0px 10px',
        justifyContent: 'center'
    },
    title: {
        fontFamily: 'mainFont',
        fontSize: 14,
        padding: '0px 5px',
        textAlign: 'justify',
        color: '#545e66'
    }
});

/**
 * @param {CreatableProps & {className: string,label: string}} props
 */
export default function Select({
    className,
    onChange,
    value,
    customStyles,
    label,
    isLab,
    clearable = false,
    ...props
}) {
    const classes = useStyles();

    return (
        <div className={`${classes.container} ${className}`}>
            <Typography className={classes.title}>{label}</Typography>
            <ReactSelect
                {...props}
                onChange={onChange}
                value={value}
                isClearable={clearable}
                styles={isLab ? labstyles : customStyles ? customStyles : styles}
            />
        </div>
    );
}

Select.propTypes = {
    className: PropTypes.any,
    label: PropTypes.string,
    isLab: PropTypes.bool,
    onChange: PropTypes.func,
    customStyles: PropTypes.object,
    value: PropTypes.object,
    clearable: PropTypes.bool
};
